import { parse, format } from "date-fns";
import React from "react";
import { connect } from "react-redux";

const PeoplesPensionGroupImport = ({ groups, currency, buddyGroups, schemeValue }) => {
	return (
		<div
			className="form-section"
			style={{ marginRight: "2rem", marginLeft: "2rem" }}
		>
			<div
				style={{
					display: "grid",
					gridGap: "1.5rem",
					grid: "1.5rem",
					gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
					padding: "1rem",
					borderBottom: "solid white 4px",
				}}
			>
				<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", opacity: "0.75" }}>
					<h5>Group</h5>
				</div>
				<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", opacity: "0.75" }}>
					<h5>Employee Contribution</h5>
				</div>
				<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", opacity: "0.75" }}>
					<h5>Employer Contribution</h5>
				</div>
				<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", opacity: "0.75" }}>
					<h5></h5>
				</div>
			</div>
			{groups?.map?.((item, index) => {
				const {
					label,
					value,
					scheme,
					employerPercentage,
					employeePercentage,
					employeeContribution,
					employerContribution,
					effective,
				} = item;
				const lastGroup = index + 1 === groups.length;
				const imported = !!buddyGroups?.find(
					({ connectionId, schemeConnectionId }) =>
						connectionId === value && schemeConnectionId === scheme,
				);

				const referenceStart = effective.start
					? format(parse(effective.start, "yyyy-MM-dd", new Date()), "dd MMM yyyy")
					: null;
				const referenceEnd = effective.end
					? format(parse(effective.end, "yyyy-MM-dd", new Date()), "dd MMM yyyy")
					: null;
				const referenceDate = `${referenceStart}${referenceEnd ? ` - ${referenceEnd}` : ""}`;

				return (
					<div
						key={`group${value}${scheme}`}
						style={{
							display: "grid",
							gridGap: "1.5rem",
							grid: "1.5rem",
							gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
							padding: "1rem",
							borderBottom: lastGroup ? undefined : "solid white 4px",
						}}
					>
						<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", paddingLeft: "1rem" }}>
							<h5>{label}</h5>
							<p style={{ marginBottom: 0 }}>{referenceDate}</p>
						</div>
						<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", paddingTop: "1rem" }}>
							<h5>
								{employeePercentage ? `${employeeContribution}%` : `${currency}${employeeContribution}`}
							</h5>
						</div>
						<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", paddingTop: "1rem" }}>
							<h5>
								{employerPercentage ? `${employerContribution}%` : `${currency}${employerContribution}`}
							</h5>
						</div>
						<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", paddingTop: "1rem" }}>
							{imported ? <div className="badge badge-success">Imported</div> : null}
							{!imported ? <div className="badge">Not Imported</div> : null}
							{/* <button
                                className="btn btn-xs btn-default"
                                onClick={() => console.log('import')}
                            >
                                Import
                            </button> */}
						</div>
					</div>
				);
			})}
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		currency: state.company?.settings?.currency,
		buddyGroups: state.pensions?.group?.list,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PeoplesPensionGroupImport);
